// Double-click edit mode for a drawn condition: pure helpers for "drag it to move it" and "drag the corner handle to make
// it larger / smaller". The geometry change itself is rotateConditions' `translate` / `scale` ops; the save (one undo step,
// room re-detected) is RoomTakeoff.transformConditions. Coordinates are world feet.
import { pointsOfRow, copyableRows } from "./conditionClipboard";

/** Never shrink a shape to (almost) nothing, and never let a stray drag blow it up past a sensible size. */
export const MIN_RESHAPE_FACTOR = 0.05;
export const MAX_RESHAPE_FACTOR = 20;

/** A hand-drawn linear run or area with a shape can be reshaped; generated rows, back-outs and symbols cannot. */
export function reshapeEligible(row) {
  if (!row || (row.Style !== "linear" && row.Style !== "area")) return false;
  return copyableRows([row]).rows.length === 1;
}

/** Bounding box of the shape, or null. */
export function reshapeBounds(row) {
  const pts = pointsOfRow(row);
  if (!pts.length) return null;
  const xs = pts.map(p => p.x), ys = pts.map(p => p.y);
  return { minX: Math.min(...xs), minY: Math.min(...ys), maxX: Math.max(...xs), maxY: Math.max(...ys) };
}

/**
 * The scale factor for a handle drag: how far the pointer is from the fixed pivot, over how far the handle started.
 * Uniform (the shape keeps its proportions). Clamped; null when the handle started on the pivot (nothing to scale by).
 */
export function scaleFactorFor(pivot, handleStart, pointer) {
  const d0 = Math.hypot(handleStart.x - pivot.x, handleStart.y - pivot.y);
  if (!(d0 > 1e-6)) return null;
  const f = Math.hypot(pointer.x - pivot.x, pointer.y - pivot.y) / d0;
  return Math.min(MAX_RESHAPE_FACTOR, Math.max(MIN_RESHAPE_FACTOR, f));
}
